<template>
  <div class="module-info">
    <!-- web面板 -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item
        :label="$t('pages.operate.text61')"
        prop="platformAdminName"
      >
        <el-input
          v-model="ruleForm.platformAdminName"
          :placeholder="$t('pages.operate.text61')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text62')">
        <DiluUploadImage
          accept=".png"
          :limit="1"
          :fileList="logoList"
          @remove="removeLogo"
          @success="successLogo"
          :uploaDisabled="false"
          :limitWidth="320"
          :limitHeight="80"
        />
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text63')">
        <DiluUploadImage
          accept=".png,.jpg"
          :limit="1"
          :fileList="bgList"
          @remove="removeBg"
          @success="successBg"
          :uploaDisabled="false"
          :limitWidth="1224"
          :limitHeight="668"
        />
      </el-form-item>
    </el-form>
    <div class="info-button" v-if="platformProperty == 1">
      <DiluButton type="prev" @click="prev"></DiluButton>
      <DiluButton type="next" @click="next"></DiluButton>
    </div>
    <div class="info-button" v-if="platformProperty == 0">
      <DiluButton type="prev" @click="prev"></DiluButton>
      <DiluButton
        type="custom"
        :title="$t('pages.operate.text24')"
        @click="submit"
      ></DiluButton>
    </div>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import DiluUploadImage from "../../../../components/pubilc/dilu-uploadimages.vue";
export default {
  data() {
    return {
      bgList: [],
      logoList: [],
      ruleForm: {
        platformAdminBackground: {
          //平台方后台登录背景图片
          imageName: "",
          imagePath: "",
        },
        platformAdminLogo: {
          //平台方后台logo
          imageName: "",
          imagePath: "",
        },
        platformAdminName: "", //平台方后台名称
      },
      rules: {
        platformAdminName: [
          {
            required: true,
            message: this.$t("pages.operate.text64"),
            trigger: "blur",
          },
          {
            max: 15,
            message: this.$t("pages.operate.text65"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    DiluUploadImage,
    DiluButton,
  },
  watch: {
    activeName(newValue) {
      if (newValue == "WebPanel") {
        this.ruleForm = {
          platformAdminBackground: this.params.platformAdminBackground,
          platformAdminLogo: this.params.platformAdminLogo,
          platformAdminName: this.params.platformAdminName, //平台方后台名称
        };
        if (this.params.platformAdminBackground.imagePath) {
          if (this.bgList.length > 0) {
            return;
          }
          this.bgList = [
            {
              name: this.params.platformAdminBackground.imageName,
              url: this.params.platformAdminBackground.imagePath,
            },
          ];
        }
        if (this.params.platformAdminLogo.imagePath) {
          if (this.logoList.length > 0) {
            return;
          }
          this.logoList = [
            {
              name: this.params.platformAdminLogo.imageName,
              url: this.params.platformAdminLogo.imagePath,
            },
          ];
        }
      }
    },
  },
  props: ["platformProperty", "activeName", "params", "pageState"],
  methods: {
    removeLogo(e) {
      const i = this.logoList.findIndex((x) => x.name == e);
      this.logoList.splice(i, 1);
      this.ruleForm.platformAdminLogo.imagePath = null;
      this.ruleForm.platformAdminLogo.imageName = null;
    },
    successLogo(e) {
      this.logoList = e.fileList;
      this.ruleForm.platformAdminLogo.imagePath = e.url;
      this.ruleForm.platformAdminLogo.imageName = e.name;
    },
    removeBg(e) {
      const i = this.bgList.findIndex((x) => x.name == e);
      this.bgList.splice(i, 1);
      this.ruleForm.platformAdminBackground.imagePath = null;
      this.ruleForm.platformAdminBackground.imageName = null;
    },
    successBg(e) {
      this.bgList = e.fileList;
      this.ruleForm.platformAdminBackground.imagePath = e.url;
      this.ruleForm.platformAdminBackground.imageName = e.name;
    },
    prev() {
      this.$emit("prev");
    },
    next() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.platformAdminBackground.imagePath) {
            return this.$message.error(this.$t("pages.operate.text66"));
          }
          if (!this.ruleForm.platformAdminLogo.imagePath) {
            return this.$message.error(this.$t("pages.operate.text67"));
          }
          this.$emit("web", this.ruleForm);
        }
      });
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.platformAdminBackground.imagePath) {
            return this.$message.error(this.$t("pages.operate.text66"));
          }
          if (!this.ruleForm.platformAdminLogo.imagePath) {
            return this.$message.error(this.$t("pages.operate.text67"));
          }
          this.$emit("submit", this.ruleForm);
        }
      });
    },
  },
};
</script>

<style scoped>
.inputs {
  width: 100%;
  display: flex;
  align-items: center;
}
.module-info {
  padding: 20px;
  box-sizing: border-box;
}
.inputs-checkout {
  margin-left: 20px;
  margin-bottom: 18px;
}
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
</style>